<template>
    <v-app-bar
      app
      extension-height="80"
      elevation="0"
      min-height="80"
      color="white"
      style="z-index: 20"
      v-if="!['login'].includes(this.$route.name)"
    >
      <v-toolbar-title class="mt-9">
        <div class="ml-10 d-flex">
          <div>
            <p class="font-weight-bold titleText--text text-capitalize mb-0">
              <span >{{ appname }}</span>
            </p>
          </div>
        </div>
        <div>
          <v-btn
            v-if="breakpointIsMobile"
            icon
            small
            class="mr-3"
            @click="toggleMenu"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            class="d-flex align-center mt-6 pl-5 pr-2 py-2 rounded mr-6"
            style="background: #F3F5F8"
            @click="menuOpen = !menuOpen"
          >
            <span class="mr-5 text-capitalize titleText--text font-weight-black text-body-2">{{ loginusername }}</span>
            <v-icon color="#505D6F" v-if="!menuOpen">mdi-chevron-down</v-icon>
            <v-icon color="#505D6F" v-else>mdi-chevron-up</v-icon>
          </div>
        </template>
        <v-list dense>
          <v-list-item @click="goTo('/logout')">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </template>
  
  <script>
  import globalval from "../../global/globalvar";
  import apifactory from "../../apis/apifactory";
  import { eventBus } from "../../main";
  // import Icon from '../../components/Icon'
  import { mapState } from "vuex";
  export default {
    components: {
      // Icon,
    },
    data: () => ({
      drawer: true,
      appname: globalval.appname,
      currentPathName: "insights",
      userid: 0,
      msg: "",
      menuOpen: false,
      appItems: [],
      links: [
        {
          icon: "mdi-clock",
          text: "Dashboard",
          route: "/dashboard",
        },
      ],
      items: [
        {
          icon: "mdi-clock",
          title: "ClientAdmin",
          url:
            "https://blog.bitsrc.io/4-best-practices-for-large-scale-vue-js-projects-9a533450bdb2",
        },
        {
          icon: "mdi-clock",
          title: "ModellingPlatform",
          url: "##",
        },
        {
          icon: "mdi-clock",
          title: "InsideStories",
          url: "#",
        },
        {
          icon: "mdi-clock",
          title: "BougetOptimiser",
          url: "#",
        },
      ],
    }),
    methods: {
      gotoHome() {
        let newurl = globalval.PARAM_GLOBAL_HOME + this.userId;
        window.location.href = newurl;
      },
      toggleMenu() {
        eventBus.$emit("toggleMenu");
      },
      goTo(url, name) {
        this.currentPathName = name;
        return this.$router.push(url);
      },
      openurl(url, app_id) {
        // let newurl="http://localhost:8081/#/ExtraAuth" +url;
        // eslint-disable-next-line no-unused-vars
        let appid = app_id;
        let newurl = url;
        window.location.href = newurl;
      },
      openmsg() {
        //alert('sss' + localStorage.getItem('SET_USERID'));
      },
      getloginuserapp() {
        apifactory
          .getloginuserapps(this.userid)
          .then((res) => {
            // alert(res.status);
  
            if (res.status != 200) {
              alert(res.data.message);
            } else {
              this.appItems = res.data;
            }
          })
          .catch(function(error) {
            console.warn(error);
          });
      },
    },
    computed: {
      ...mapState(["loginusername"]),
      userId() {
        return localStorage.getItem("SET_USERID");
      },
      loginusername() {
        return localStorage.getItem("SET_USERNAME");
      },
      currentProjectId() {
        return window.location.hash.split("/")[2];
      },
      breakpointIsMobile() {
        return ["xs"].includes(this.$vuetify.breakpoint.name);
      },
      project () {
        return JSON.parse(localStorage.getItem('project'))
      }
    },
    mounted() {
      if (this.$route.name !== 'dashboard') {
        this.modelOutcomeStore.fetchData()
      }
      this.getloginuserapp();
    },
  };
  </script>
  <style scoped>
  .margin-appname {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .margin-icon {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }
  .v-divider-new {
    border-color: rgba(247, 247, 247, 0.12) !important;
    width: 2% !important;
  }
  
  .cursor__pointer {
    cursor: pointer;
  }
  
  div.btn__content {
    padding: 0 !important;
  }
  </style>
  